import TTDetailHTMLPreviewHeader from './TTDetailHTMLPreviewHeader'
import TTDetailHTMLPreviewTotalSection from './TTDetailHTMLPreviewTotalSection'
import TTDetailHTMLPreviewGroupingSection from './TTDetailHTMLPreviewGroupingSection'

export default function TTDetailHTMLPreviewGenerator() {}

TTDetailHTMLPreviewGenerator.prototype.init = function() {
    return this
}

TTDetailHTMLPreviewGenerator.prototype.generatePreviewTable = function(reportParameters) {
    // if there is collision clear third level
    const groupingLevels = TTDetailPreviewUtils.filterGroupingLevelsIfExistCollision(
        [
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel
        ],
        reportParameters.joinCommentsByTask
    )

    const notEmptyGroupingLevels = ReportPreviewUtils.filterNotEmptyLevels(groupingLevels)
    const joinCommentsByTask = reportParameters.joinCommentsByTask
    const detailsLevels = TTDetailPreviewUtils.calculateTTCDetailCells(notEmptyGroupingLevels, joinCommentsByTask)

    const needSwitchToMe = reportParameters.needSwitchToMe
    const headerSection = new TTDetailHTMLPreviewHeader().init(notEmptyGroupingLevels, detailsLevels, joinCommentsByTask, needSwitchToMe)
    const totalSection = new TTDetailHTMLPreviewTotalSection().init(detailsLevels.length, reportParameters.timeFormat)
    const groupingSection = new TTDetailHTMLPreviewGroupingSection().init(
        notEmptyGroupingLevels,
        detailsLevels,
        joinCommentsByTask,
        reportParameters.timeFormat,
        needSwitchToMe,
    )

    const table = document.createElement("table")
    table.className = "reportHtmlPreviewTable ttdetail"
    const tBody = document.createElement("tbody")
    table.appendChild(tBody)

    headerSection.addRows(tBody)
    totalSection.addRows(tBody)
    groupingSection.addRows(tBody)

    return table
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/ttdetail/TTDetailHTMLPreviewGenerator.js